import React from "react";
import Link from "gatsby-link";

import styles from './Jumbotron.css';

class Jumbotron extends React.Component {

  render() {
    return (
      <div className="Jumbotron">
        <div className="Jumbotron__Background">
          <div className="Jumbotron__Image" />
        </div>
        <div className="Jumbotron__Text Container">
          <h1>{this.props.message}</h1>
          {this.props.subhead}
        </div>
      </div>
    );
  }
}

export default Jumbotron;



// WEBPACK FOOTER //
// ./src/components/Jumbotron/Jumbotron.jsx